module.exports = __webpack_public_path__ + "static/media/1009860.db90edc2.jpg";